<script>
import Vue from "vue";

Vue.prototype.$cheapest_xCode = "";
Vue.prototype.$cheapest_kodId = "";
Vue.prototype.$cheapest_tourOp = "";
Vue.prototype.$cheapest_htlCode = "";

export default {
  name: "t1content",
  loadMissingURLParams: function(path) {
    console.log("PATH:" + path);
    var that = this;
    var insUrl =
      "https://www.travelone.pl/cheapestvueoffer.xml?path=" +
      encodeURIComponent(path);
    var result = jQuery.ajax({
      url: insUrl,
      dataType: "xml",
      crossDomain: true,
      method: "GET",
      success: function(data) {
        var xmlObj = jQuery(data);
        that.$cheapest_tourOp = xmlObj.find("ofr").attr("tourOp");
        that.$cheapest_kodId = xmlObj.find("ofr").attr("id");
        that.$cheapest_xCode = xmlObj.find("obj").attr("xCode");
        that.$cheapest_htlCode = xmlObj.find("obj").attr("code");
        console.log("cheapest_xCode:" + that.$cheapest_xCode);
        console.log("cheapest_kodId:" + that.$cheapest_kodId);
        console.log("cheapest_tourOp:" + that.$cheapest_tourOp);
        console.log("cheapest_htlCode:" + that.$cheapest_htlCode);
      },
      error: function(e) {
        console.log(e);
        console.log("Ajax Error");
      }
    });
    return result;
  },
  loadSchowekOffers: function() {
    console.log("Load schowek offers...");
    var that = this;
    var insUrl = "https://www.travelone.pl/oferta/syncschowekoffers.xml";
    var result = jQuery.ajax({
      url: insUrl,
      dataType: "xml",
      xhrFields: { withCredentials: true },
      crossDomain: true,
      method: "GET",
      success: function(data) {
        var xmlObj = jQuery(data);
        xmlObj.find("offer").each(function(index, elem) {
          var ofr_id = jQuery(elem)
            .find("kodId")
            .text();
          console.log("OFERTA w schowku:" + ofr_id);
          //that.$schowek_offers.push(ofr_id);
        });
      },
      error: function(e) {
        console.log(e);
        console.log("Ajax Error");
      }
    });
    return result;
  }
};
</script>
